import { fulfilled, pending, rejected } from '../../../utils';
import { MY_LOAN } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const myLoanReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(MY_LOAN):
			return {
				...state,
				loading: true,
				message: '',
				error: '',
			};
		case fulfilled(MY_LOAN):
			return {
				...state,
				loading: false,
				status: action.payload.data.status,
				message: action.payload.data.message,
				data: action.payload.data.data,
				error: '',
			};
		case rejected(MY_LOAN):
			return {
				...state,
				loading: false,
				message: '',
				error: status ===500 ? "Something went wrong. Please try again later" : action?.payload?.response.data.message,
			};
		default:
			return state;
	}
};

export default myLoanReducer;
